import React from 'react'
import { TabBar, Tab, TabPanel } from '.';
import { WrapperTab } from './Tabs.styles';


const Tabs = ({ configFile, activeTab = 1, setActiveTab = null, ...props }) => {
    const tabs = configFile.map(({ tab }) => tab);
    return (
        <WrapperTab>
            <TabBar initialTab={tabs[activeTab]}>
                <div className='headerTab'>
                    <nav className='navTab'>
                        {
                            configFile.map(({ tab, title }) => (
                                <Tab key={title} tab={tab} tag='span' setActiveTab={setActiveTab} >
                                    <button>{title}</button>
                                </Tab>
                            ))
                        }
                    </nav>
                </div>
                <div className='mainTab'>
                    {
                        configFile.map(({ Contents, tab, title }) => (
                            <TabPanel key={title} whenActive={tab}>
                                <Contents
                                    {...props}
                                    activeTab={activeTab}
                                />
                            </TabPanel>
                        ))
                    }
                </div>
            </TabBar>
        </WrapperTab>
    )
}

export default Tabs
